import React, { useEffect, useMemo } from 'react';
import ReactDOM from 'react-dom';
import cn from 'classnames';
import styles from './styles.scss';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { closeModal } from '../../actions/component_actions';
import { MODALS } from './constants';

const Modal = ({ modal }) => {
  const container = document.getElementById('modal');
  const onClose = () => window.store.dispatch(closeModal({ modalName: modal.modalName }));
  const CurrentModal = useMemo(() => MODALS[modal.modalName], [modal]);

  useEffect(() => {
    if (!!modal.modalName && !!modal.show) {
      document.body.style.overflow = 'hidden';
    }
  }, [modal]);

  if (!container) return <></>;

  if (!modal.show) {
    document.body.style.overflow = 'auto';
    return <></>;
  }

  return ReactDOM.createPortal(
    <div className={cn(styles.modal, 'custom-modal')}>
      <div className={styles.modalOverlay} onClick={onClose} />
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <div className={styles.title}>{CurrentModal.title}</div>
          <button className={cn(styles.closeButton, 'close-button')} onClick={onClose}>
            <img src="https://cdn.ticketspot.io/widget/layout-icons/shared/modal/modalClose.svg" alt="x" />
          </button>
        </div>
        <div className={styles.modalBody}>
          <CurrentModal.Component {...modal.data} />
        </div>
      </div>
    </div>,
    container
  );
};

const mapStateToProps = (state) => ({
  modal: state.component.get('modals'),
});

Modal.propTypes = {
  modal: PropTypes.instanceOf(Map),
};

const ModalWithProps = connect(mapStateToProps, null)(Modal);
export default ModalWithProps;
